// components/templates/sections/BookingSection.tsx
'use client';
import { useState } from 'react';
import { useDesign } from '@/context/DesignContext';

interface BookingSectionProps {
  subtitle?: string;
  title: string;
  description: string;
  design?: any;
}

export default function BookingSection({
  subtitle = 'ONLINE RESERVATION',
  title,
  description,
  design: propDesign,
}: BookingSectionProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [arrivalTime, setArrivalTime] = useState('');
  const [people, setPeople] = useState('');
  const [date, setDate] = useState('');

  const headingFont = design?.typography?.headingFont || "'Sora', sans-serif";
  const bodyFont = design?.typography?.bodyFont || "'Plus Jakarta Sans', sans-serif";
  const primaryColor = design?.colors?.primary || '#E07A5F';
  const textColor = design?.colors?.text || '#1E1E1E';
  const borderColor = design?.colors?.border || '#E9ECEF';
  const btnPrimary = design?.buttons?.primary || {
    class: 'tf-button style1',
    backgroundColor: 'var(--primary)',
    textColor: '#FFFFFF',
    borderRadius: '30px',
    padding: '12px 30px',
  };
  const containerMaxWidth = design?.spacing?.containerMaxWidth || '1200px';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Traitement du formulaire
  };

  const subtitleStyle: React.CSSProperties = {
    fontFamily: headingFont,
    color: primaryColor,
    marginBottom: '0.5rem',
  };
  const titleStyle: React.CSSProperties = {
    fontFamily: headingFont,
    fontSize: '2rem',
    fontWeight: 600,
    color: textColor,
    marginBottom: '1rem',
  };
  const descStyle: React.CSSProperties = {
    fontFamily: bodyFont,
    color: design?.colors?.textLight || '#6C757D',
    lineHeight: 1.6,
    marginBottom: '2rem',
  };
  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '0.75rem',
    border: `1px solid ${borderColor}`,
    borderRadius: '4px',
    fontFamily: bodyFont,
    marginBottom: '1rem',
  };
  const buttonStyle: React.CSSProperties = {
    backgroundColor: btnPrimary.backgroundColor,
    color: btnPrimary.textColor,
    padding: btnPrimary.padding,
    borderRadius: btnPrimary.borderRadius,
    border: 'none',
    cursor: 'pointer',
    width: '100%',
    fontFamily: headingFont,
    fontWeight: 'bold',
  };

  return (
    <section className="booking" style={{ padding: '60px 0' }}>
      <div className="container" style={{ maxWidth: containerMaxWidth, margin: '0 auto' }}>
        <div className="row">
          <div className="col-md-6">
            <div className="booking-content">
              <div className="block-text style-2">
                <p className="subtitle" style={subtitleStyle}>{subtitle}</p>
                <h3 className="title" style={titleStyle}>{title}</h3>
                <p className="text" style={descStyle}>{description}</p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="booking-form">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name*"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={inputStyle}
                    required
                  />
                </div>
                <div className="form-row" style={{ display: 'flex', gap: '1rem' }}>
                  <div className="form-group" style={{ flex: 1 }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone*"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      style={inputStyle}
                      required
                    />
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <select className="form-control" value={arrivalTime} onChange={(e) => setArrivalTime(e.target.value)} style={inputStyle}>
                      <option value="">Arrival time</option>
                      <option>12:00</option>
                      <option>13:00</option>
                      <option>14:00</option>
                    </select>
                  </div>
                </div>
                <div className="form-row" style={{ display: 'flex', gap: '1rem' }}>
                  <div className="form-group" style={{ flex: 1 }}>
                    <select className="form-control" value={people} onChange={(e) => setPeople(e.target.value)} style={inputStyle}>
                      <option value="">Amount of people</option>
                      <option>1 person</option>
                      <option>2 persons</option>
                      <option>3 persons</option>
                      <option>4+ persons</option>
                    </select>
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <select className="form-control" value={date} onChange={(e) => setDate(e.target.value)} style={inputStyle}>
                      <option value="">18/6/2023</option>
                      <option>19/6/2023</option>
                      <option>20/6/2023</option>
                    </select>
                  </div>
                </div>
                <button type="submit" className={btnPrimary.class} style={buttonStyle}>book a table</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}